/**
 * Mutación para cargar la información de los epp icos de un producto químico.
 *
 * @param {*} state contiene la información de las variables del formulario.
 * @param {*} eppIcos contiene la informacion de los epp icos de un producto químico.
 */
export function cargarEppIcos(state, eppIcos) {
    state.selectedEpp.layer_ocular = eppIcos.ocular[0];
    state.selectedEpp.layer_cutanea = eppIcos.cutanea[0];
    state.selectedEpp.layer_respiratoria = eppIcos.respiratoria[0];
    state.selectedEpp.layer_calzado = eppIcos.calzado[0];
    state.selectedEpp.layer_ropa = eppIcos.ropa[0];
}
